/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC, useEffect, useState} from 'react'
import {PageLink, PageTitle} from '../../../_metronic/layout/core'
import { getClientAllPagination } from '../../services/clientService';
import { getPlantsAllSimple } from '../../services/plantsService';
import { getUsersAll } from '../../services/usersService';
import { getTagsAll } from '../../services/tagsService';
import { Loading } from '../components/Loadings/loading';
import { useToast } from '../components/Toats';
import { TableClients } from './components/TableClients';
//import { MyPortal } from './components/my-portal'

type Paginations = {
  page: number,
  limit: number,
  total: number,
  qtdPages: number
}

type SetPaginations = {
  start: number;
  end: number;
};

const clientsBreadcrumbs: Array<PageLink> = [
  {
    title: 'Dashboard',
    path: '/dashboard',
    isSeparator: false,
    isActive: false,
  },
  {
    title: '',
    path: '',
    isSeparator: true,
    isActive: false,
  },
]

const ClientsPage: FC = () => {
    const { toggleToast } = useToast()

    const [filterName, setFilterName] = useState<string>("");
    const [filterLinkedUser, setFilterLinkedUser] = useState<string>("");
    const [filterUserId, setFilterUserId] = useState<string>("");
    const [filterHasPlant, setFilterHasPlant] = useState<string>("");
    const [filterPlantId, setFilterPlantId] = useState<string>("");
    const [filterTag, setFilterTag] = useState<string>("");
    const [clients, setClients] = useState<any>([]);
    const [clientsLoading, setclientsLoading] = useState<any>(true);
    const [plants, setPlants] = useState<any[]>([]);
    const [users, setUsers] = useState<any[]>([]);
    const [tags, setTags] = useState<any[]>([]);
    const [pagination, setPagination] = useState<Paginations>({
      page: 1,
      limit: 10,
      total: 0,
      qtdPages: 1
    });

    const [qtd, setQtd] = useState<SetPaginations>({
      start: 0,
      end: 10,
    });

    const getClients = async () => {
        try {
          setclientsLoading(true)
          const myClient = await getClientAllPagination(
            undefined,
            filterLinkedUser === "" ? undefined : filterLinkedUser === "true",
            filterUserId || undefined,
            pagination.limit,
            pagination.page,
            filterName,
            filterHasPlant === "" ? undefined : filterHasPlant === "true",
            filterPlantId || undefined,
            filterTag || undefined
          )
          if(myClient){
            setPagination({...pagination, qtdPages: myClient.lastPage, total: myClient.total})
            setClients(myClient.data)
          }

        } catch (error) {
          console.log(error)
          toggleToast("Erro ao buscar os clientes!", "error")
        }finally{
          setclientsLoading(false)
        }
    }

    const getFilterOptions = async () => {
      try {
        const [myPlants, myUsers, myTags] = await Promise.all([
          getPlantsAllSimple(),
          getUsersAll(),
          getTagsAll(),
        ])
        setPlants(Array.isArray(myPlants) ? myPlants : myPlants?.data || [])
        setUsers(Array.isArray(myUsers) ? myUsers : myUsers?.data || [])
        setTags(Array.isArray(myTags) ? myTags : myTags?.data || [])
      } catch (error) {
        console.log(error)
      }
    }

    const refresh = () => {
      getClients()
    }

    useEffect(() => {
      getFilterOptions()
    }, []);

    useEffect(() => {
      getClients()
    }, [pagination.page, filterName, filterLinkedUser, filterUserId, filterHasPlant, filterPlantId, filterTag]);

    useEffect(() => {
      const start = (pagination.page - 1) * pagination.limit + 1;
      const end = Math.min(pagination.page * pagination.limit, pagination.total);
  
      setQtd({start: start, end: end === 0 ? pagination.limit : end})
      
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pagination.page]);



  return (
    <div className='column g-5 g-xl-8'>
        <TableClients
          className='card-xl-stretch mb-xl-8'
          clients={clients && clients.length > 0 ? clients : []}
          refresh={refresh}
          pagination={pagination}
          setPagination={setPagination}
          qtd={qtd}
          loading={clientsLoading}
          setFilterName={setFilterName}
          plants={plants}
          users={users}
          tags={tags}
          filterLinkedUser={filterLinkedUser}
          setFilterLinkedUser={setFilterLinkedUser}
          filterUserId={filterUserId}
          setFilterUserId={setFilterUserId}
          filterHasPlant={filterHasPlant}
          setFilterHasPlant={setFilterHasPlant}
          filterPlantId={filterPlantId}
          setFilterPlantId={setFilterPlantId}
          filterTag={filterTag}
          setFilterTag={setFilterTag}
        />
    </div>
  )
}

const ClientsWrapper: FC = () => {
  return (
    <>
      <PageTitle breadcrumbs={clientsBreadcrumbs}>Gerenciamento de Clientes</PageTitle>
      <ClientsPage />
    </>
  )
}

export {ClientsWrapper}
